import clsx from 'clsx';

import { stepper } from '@gitbook/doc-core';
import { useEditor } from '@gitbook/slate-react';
import { Icon } from '@gitbook/spine-icons';
import { Button } from '@gitbook/spine-react';
import { assert } from '@gitbook/util-ts';

export function InsertStepButton(props: {
    visible: boolean;
    stepperStepKey: string;
    className?: string;
}) {
    const editor = useEditor();
    return (
        <div
            className={clsx(
                'origin-center transform transition',
                props.visible ? 'scale-100 opacity-100' : 'scale-75 opacity-0',
                props.className
            )}
        >
            <Button
                label="Insert a new step"
                iconOnly
                leadingIcon={Icon.Plus}
                rounded
                kind="secondary"
                size="small"
                onPress={() => {
                    const stepBlock = editor.value.document.assertBlock(props.stepperStepKey);
                    const stepperBlock = editor.value.document.getParent(stepBlock.key);
                    assert(stepperBlock, 'Stepper step must have a parent stepper block');
                    const index = stepperBlock.getChildIndex(props.stepperStepKey);
                    editor.change((change) =>
                        stepper.insertStepperStepAt(change, stepperBlock.key, index + 1)
                    );
                }}
            />
        </div>
    );
}
